module.exports = __webpack_public_path__ + "img/CMHK_01_zhCn.6458fe89.png";